export default {
  "content": "<path fill=\"#fff\" d=\"M19.305 13c-2.511 0-5.973-5.167-7-6.5C11.278 5.167 9.217 0-.195 0h39c-9.411 0-11.473 5.167-12.5 6.5-1.026 1.333-4.489 6.5-7 6.5\"/>",
  "attrs": {
    "class": "popover-menu__arrow-shape",
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "39",
    "height": "13",
    "viewBox": "0 0 39 13"
  }
};